import React from 'react';
import './checkbox.css';

const Checkbox = props => {
  return (
    <label className="checkbox">
      <span className="checkbox__text">{props.text}</span>
      <input
        type="checkbox"
        name={props.name}
        className="checkbox__input"
        onChange={props.onChange}
        checked={props.checked}
      />
      <span className="checkbox__icon"></span>
    </label>
  );
};

export default Checkbox;
